// lib/tickets/rechnungsEmpfaenger.ts
// #534: Wer steht in der Handwerker-Beauftragung unter „Rechnungsanschrift“ / „Eigentümer / WEG“?

export interface RechnungsEmpfaengerEingabe {
  /** direkt am Ticket verknüpfter Eigentümer (#513) */
  ticketEigentuemer: string | null;
  /** von der Mail-Analyse erkannter Eigentümer */
  analyseEigentuemer: string | null;
  /** aktueller Eigentümer der betroffenen Einheit */
  einheitEigentuemer: string | null;
  objekttyp: string | null;
  objektBezeichnung: string | null;
  /** „Teststraße 88, 12345 Musterstadt“ */
  objektAdresse: string;
  /** alle Eigentümer am Objekt (objekt_eigentuemer) */
  objektEigentuemer: string[];
}

/**
 * Reihenfolge: Ticket → Analyse → Einheit. Ohne Einheit ist bei einer WEG die
 * Gemeinschaft Rechnungsempfänger (Gemeinschaftseigentum), sonst alle Eigentümer des
 * Objekts — bei mehreren (z. B. Ehepaar) alle Namen statt keinem.
 */
export function rechnungsEmpfaenger(e: RechnungsEmpfaengerEingabe): string | null {
  const direkt = e.ticketEigentuemer || e.analyseEigentuemer || e.einheitEigentuemer;
  if (direkt) return direkt;
  if ((e.objekttyp ?? '').trim().toUpperCase() === 'WEG') {
    const bez = (e.objektBezeichnung ?? '').trim();
    if (/^WEG\b/i.test(bez)) return bez;
    return e.objektAdresse ? `WEG ${e.objektAdresse}` : 'WEG';
  }
  const namen = [...new Set(e.objektEigentuemer.map((n) => n.trim()).filter(Boolean))];
  if (namen.length === 0) return null;
  if (namen.length === 1) return namen[0];
  return `${namen.slice(0, -1).join(', ')} und ${namen[namen.length - 1]}`;
}
